import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, exhaustMap, map, mergeMap, tap} from 'rxjs/operators';
import * as GlobalMessageActions from '../../core/actions/global-message.actions';
import {GlobalMessage, GlobalMessageType} from '../../core/models/global-message';
import * as AuthActions from '../../user/actions/user.actions';
import * as CountriesActions from '../actions/countries.actions';
import {Country} from '../model/country';
import {QuotesError} from '../model/quotes-error';
import {CountriesService} from '../services/countries.service';

@Injectable()
export class CountriesEffects {

    $login = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.loginSuccess, AuthActions.validateAuthTokenLoggedIn),
            exhaustMap(action => [
                CountriesActions.loadCountries()
            ])
        ));

    $loadCountries = createEffect(() => this.actions$
        .pipe(
            ofType(CountriesActions.loadCountries),
            tap(action => console.log('load countries')),
            exhaustMap(action => this.countriesService.getCountries().pipe(
                map((countries: Country[]) => CountriesActions.loadCountriesSuccess({countries})),
                catchError(error => of(CountriesActions.loadCountriesFailure(({error: (<QuotesError>error).errorMessage})))
                ))
            )));

    $loadCountriesFailure = createEffect(() => this.actions$
        .pipe(
            ofType(CountriesActions.loadCountriesFailure),
            mergeMap((action) => {
                const message: GlobalMessage = {
                    id: 'countries-loading-failure',
                    type: GlobalMessageType.ERROR,
                    message: 'The countries couldn\'t be loaded: ' + action.error
                };
                return of(GlobalMessageActions.addMessage({globalMessage: message}));
            }))
    );

    constructor(private actions$: Actions, private countriesService: CountriesService) {
    }
}
